<template>
  <div>
    <div id="func-content">
      <b-card class="bg-default-card">
        <div class="row">
          <div class="col-lg-12">
            <div class="row mt-2">
              <label class="control-label col-md-2">品牌：</label>
              <div class="col-md-3">
                <select
                        id="brandsCode"
                        name="brandsCode"
                        class="form-control"
                        v-model="search.brandsCode"
                      >
                      <option
                        v-for="x in selectListBrands"
                        v-bind:value="x.Code"
                        :key="x.Code"
                      >{{x.Text}}</option>
                </select>
              </div>
              <label class="control-label col-md-2">日期：</label>
              <div class="col-md-3">
                <input
                  type="date"
                  class="form-control"
                  v-model="search.sdate"
                  max="9999-12-31"
                />
                <div class="text-danger" v-if="valid_sdate && !search.sdate">
                  {{ valid_sdate }}
                </div>
              </div>
              <div class="col-md-2">
                <button
                  type="button"
                  class="btn btn-ptc1"
                  @click="getquery(search.sdate)"
                >
                  查詢
                </button>
              </div>
            </div>
            <div class="row mt-2">
              <label class="control-label col-md-2">店號：</label>
              <div class="col-md-3">
                <input
                  type="text"
                  class="form-control"
                  v-model="search.code"
                  placeholder="請輸入店號"
                />
              </div>
              <label class="control-label col-md-2">店名：</label>
              <div class="col-md-3">
                <input
                  type="text"
                  class="form-control"
                  v-model="search.name"
                  placeholder="模糊搜尋"
                />
              </div>
              <div class="col-md-2">
                <button type="button" class="btn btn-ptc1" @click="reset">
                  重設
                </button>
              </div>
            </div>
          </div>
        </div>
      </b-card>

      <b-card class="bg-default-card">
        <div class="row">
          <div class="col-lg-12">
            <div style="float: left">
              <button type="button" class="btn btn-ptc1" @click="query(-7)">
                &lt;
              </button>
              <button type="button" class="btn btn-ptc1" @click="query(7)">
                &gt;
              </button>
            </div>
            <div style="float: right">
              <button
                type="button"
                class="btn btn-warning text-white"
                v-show="FunctionPermission > 1"
                @click="add"
              >
                新增
              </button>
              <button
                type="button"
                class="btn btn-danger"
                v-show="!delmode && FunctionPermission > 1"
                @click="openDelMode()"
              >
                開啟刪除模式
              </button>
              <button
                type="button"
                class="btn btn-secondary"
                v-show="delmode && FunctionPermission > 1"
                @click="closeDelMode()"
              >
                關閉刪除模式
              </button>
            </div>
            <table style="width: 100%">
              <tr>
                <td v-for="j in weekdays" :key="j.Date" style="width: 14%">
                  <div
                    style="
                      border: #bebebe 1px solid;
                      text-align: center;
                      height: 80px;
                    "
                  >
                    {{ turnWeek(j.Week) }}<br />{{ j.Date }}
                  </div>
                  <div
                    style="
                      border: #bebebe 1px solid;
                      text-align: left;
                      height: 500px;
                      overflow: auto;
                    "
                  >
                    <div v-for="i in j.Detail" :key="i.Source">
                      {{ i.Source == "1" ? "店休" : "門市關單" }}
                      <ul>
                        <li v-for="x in i.List" :key="x.ID">
                          <div
                            v-if="
                              (x.Type == 1 && !delmode) ||
                              (x.Type == 1 && j.Date < today2)
                            "
                          >
                          {{ x.BrandCode }}_全門市
                          </div>
                          <button
                            type="button"
                            class="linkbutton"
                            @click="showDelete(x, i.Source, j.Date, j.Week)"
                            v-if="x.Type == 1 && delmode && j.Date >= today2"
                          >
                          {{ x.BrandCode }}_全門市
                          </button>
                          <div
                            v-if="
                              (x.Type == 2 && !delmode) ||
                              (x.Type == 2 && j.Date < today2)
                            "
                          >
                          {{ x.BrandCode }}_{{ x.StoreCode }} {{ x.StoreName }}
                          </div>
                          <button
                            type="button"
                            class="linkbutton"
                            @click="showDelete(x, i.Source, j.Date, j.Week)"
                            v-if="x.Type == 2 && delmode && j.Date >= today2"
                          >
                          {{ x.BrandCode }}_{{ x.StoreCode }} {{ x.StoreName }}
                          </button>
                        </li>
                      </ul>
                    </div>
                  </div>
                </td>
              </tr>
            </table>
          </div>
        </div>
      </b-card>

      <!-- 新增畫面Modal -->
      <b-modal ref="mdEdit" hide-footer size="lg" :title="brandCode + '_新增店休'">
        <b-container fluid>
          <div class="row col-lg-12">
            <div class="col-md-2">
              <label class="control-label">日期：</label>
            </div>
            <div class="col-md-4">
              <input
                type="date"
                class="form-control"
                v-model="hdates"
                :min="today"
                max="9999-12-31"
              />
              <div class="text-danger" v-if="valid_hdates">
                {{ valid_hdates }}
              </div>
            </div>
            <label class="mt-2">至</label>
            <div class="col-md-4">
              <input
                type="date"
                class="form-control"
                v-model="hdatee"
                :min="today"
                max="9999-12-31"
              />
              <div class="text-danger" v-if="valid_hdatee">
                {{ valid_hdatee }}
              </div>
            </div>
          </div>
          <div class="col-lg-12">
            <b-form-radio-group v-model="store_type">
              <div class="row">
                <div class="col-lg-12">
                  <b-form-radio value="1">全門市</b-form-radio>
                </div>
                <div class="col-lg-3 mt-3">
                  <b-form-radio value="2">特定門市</b-form-radio>
                </div>
                <div class="col-lg-3 mt-2">
                  <select
                    class="form-control"
                    :disabled="!(store_type == 2)"
                    v-model="ddl_city"
                    @change="ddlCityChange"
                  >
                    <option value="0" disabled>請選擇地區</option>
                    <option v-for="x in stores" :value="x" :key="x.City">
                      {{ x.City }}
                    </option>
                  </select>
                </div>
                <div class="col-lg-3 mt-2">
                  <select
                    class="form-control"
                    :disabled="!(store_type == 2)"
                    v-model="ddl_district"
                    @change="ddlDistrictChange"
                  >
                    <option value="0" disabled>請選擇行政區</option>
                    <option
                      v-for="x in ddl_city.Districts"
                      :value="x"
                      :key="x.District"
                    >
                      {{ x.District }}
                    </option>
                  </select>
                </div>
                <div
                  class="text-danger"
                  style="margin-top: 15px"
                  v-if="store_type == 2 && valid_stores"
                >
                  {{ valid_stores }}
                </div>

                <div class="col-lg-12 row mt-3" v-show="store_type == 2">
                  <div class="col-lg-4">
                    <b-form-group>
                      <template slot="label">
                        <b-form-checkbox v-if="ddl_city == 0" disabled
                          >請選擇地區</b-form-checkbox
                        >
                        <b-form-checkbox
                          v-else
                          v-model="chk_all_selected"
                          @change="toggleAll"
                          >{{ ddl_district.District }}</b-form-checkbox
                        >
                      </template>
                      <b-form-checkbox-group
                        v-model="multiple_stores"
                        style="height: 200px; overflow: auto"
                        stacked
                      >
                        <b-form-checkbox
                          v-for="x in ddl_district.Stores"
                          :value="x"
                          :key="x.ID"
                          >{{ x.Name }}</b-form-checkbox
                        >
                      </b-form-checkbox-group>
                    </b-form-group>
                  </div>
                  <div class="col-lg-1" style="padding-left: 0px">
                    <button
                      type="button"
                      class="btn btn-ptc1"
                      style="margin-top: 100px; margin-left: 0px"
                      @click="addMultStores"
                    >
                      &gt;
                    </button>
                  </div>
                  <div class="col-lg-7 row box1color">
                    <div class="my-scrollbar">
                      <div class="row">
                        <div
                          class="col-lg-6"
                          v-for="s in selected_stores"
                          :key="s.ID"
                        >
                          <b-button
                            class="btn btn-outline-light mt-1"
                            @click="delStore(s)"
                            ><span class="fas fa-trash-alt"></span></b-button
                          >{{ s.BrandCode }}_{{ s.Name }}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </b-form-radio-group>
          </div>
          <div class="cog-lg-12">
            <div class="row float-right cog-lg-12">
              <b-btn
                class="mt-3" variant="primary"
                @click="addCheck()"
                :disabled="addsaveClick"
                >儲存</b-btn
              >&nbsp;
              <b-btn
                class="mt-3" variant="secondary"
                @click="addCancel()"
                >取消</b-btn
              >&nbsp;
            </div>
          </div>
        </b-container>
      </b-modal>
      <!-- Delete Check Modal -->
      <b-modal
        ref="mdDelete"
        hide-footer
        :title="'取消' + (md_Source == 1 ? '店休' : '門市關單')"
      >
        <b-container fluid>
          <form>
            <div class="row mb-3">
              <label class="control-label"
                >{{ md_theDate }} {{ md_BrandCode }}_{{ md_Name }} 確定取消{{
                  md_Source == 1 ? "店休" : "門市關單"
                }}?</label
              >
            </div>
            <div class="float-right">
              <b-btn variant="primary" @click="delConfirm">確定</b-btn>
              <b-btn variant="secondary" @click="delCancel">取消</b-btn>
            </div>
          </form>
        </b-container>
      </b-modal>
      <b-modal ref="mdCancelCheck" hide-footer title="取消訂單提醒">
        <b-container fluid>
          <form>
            <div class="row mb-3">
              <label class="control-label">提醒您，<br />店休日為<b>當日</b>訂單須由<font style="color:red">人員手動執行退貨</font>；<br />
                店休日為<b>非當日</b>訂單由<font style="color:red">系統執行自動取消</font>。<br />確定要新增店休，並自動取消非當日訂單 ?</label>
            </div>
            <div class="float-right">
              <b-btn variant="primary" @click="addsave()">確定</b-btn>
              <b-btn variant="secondary" @click="closeCancelCheck()">取消</b-btn>
            </div>
          </form>
        </b-container>
      </b-modal>
    </div>
  </div>
</template>
<script src="//cdnjs.cloudflare.com/ajax/libs/vue/2.5.2/vue.min.js"></script>
<script>
import { getFunctionPermission } from "../../../js/LoginUserFunction.js";
import { API_URL } from "../../../store/root.js";
import miniToastr from "mini-toastr";
import VModal from "vue-js-modal";
import axios from "axios";
miniToastr.init();
export default {
  data() {
    return {
      delmode: false,
      search: {
        sdate: "",
        code: "",
        name: "",
        brandsCode: "MWD",
      },
      API_URL: API_URL,
      FunctionPermission: 0,
      valid_sdate: "",
      selectListBrands: [{ ID: 0, Code: '', Text: '' }],
      brandCode: "",
      // 周曆
      lists: [],
      weekdays: [],
      sSunday: "",
      // 新增
      hdates: "",
      hdatee: "",
      valid_hdates: "",
      valid_hdatee: "",
      valid_stores: "",
      store_type: 2,
      ddl_city: 0,
      ddl_district: 0,
      stores: [],
      multiple_stores: [],
      selected_stores: [],
      chk_all_selected: false,
      addsaveClick: false, // 避免連按兩次
      today: "",
      today2: "",
      // 刪除
      md_ID: 0,
      md_BrandCode: "",
      md_StoreCode: "",
      md_Name: "",
      md_Source: "",
      md_theDate: "",
      md_week: "",
    };
  },
  created() {
    this.FunctionPermission = getFunctionPermission("F34"); // 功能權限
    if (this.FunctionPermission < 1) {
      this.$router.push({ name: "name" });
      return;
    }
    this.setStartDate();
    this.getquery(this.search.sdate);
    this.querySelectListBrands();
  },
  methods: {
    turnWeek(week) {
      if (week == "1") {
        return "一";
      } else if (week == "2") {
        return "二";
      } else if (week == "3") {
        return "三";
      } else if (week == "4") {
        return "四";
      } else if (week == "5") {
        return "五";
      } else if (week == "6") {
        return "六";
      } else if (week == "7") {
        return "日";
      } else {
        return "";
      }
    },
    reset() {
      this.setStartDate();
      this.search.code = "";
      this.search.name = "";
      this.search.brandsCode = "MWD";

      this.getquery(this.search.sdate);
    },
    formatDate(sunday) {
      var year = sunday.getFullYear();
      var mon = sunday.getMonth() + 1;
      var day = sunday.getDate();

      if (mon < 10) {
        mon = "0" + mon;
      }
      if (day < 10) {
        day = "0" + day;
      }
      return year + "/" + mon + "/" + day;
    },
    getquery(date) {
      var newDate = new Date(date);
      var week = newDate.getDay(); // 今天是禮拜幾
      newDate.setDate(newDate.getDate() - week); // 設第一天為禮拜日
      this.sSunday = newDate;
      console.log(this.sSunday);

      this.valid_errMsg = false;
      if (!this.search.sdate) {
        this.valid_errMsg = true;
        this.valid_sdate = "日期為必填";
      } else {
        this.valid_sdate = "";
      }
      if (this.valid_errMsg) {
        this.$parent.$parent.verificationErrMsg();
        return;
      }

      this.query(0);
    },
    query(thedate) {
      if (thedate != 0) {
        // 上/下禮拜
        this.sSunday.setDate(this.sSunday.getDate() + thedate);
      }
      var fSunday = this.formatDate(this.sSunday);
      this.weekdays = [];
      this.$parent.Loading = true;
      return axios
        .post(API_URL + "/web/shopping/getAllStoreHolidays/v1", {
          sdate: fSunday,
          code: this.search.code,
          name: this.search.name,
          brandCode: this.search.brandsCode,
        })
        .then((response) => {
          this.$store.commit("TOKEN", response.data.jwt);
          this.$parent.Loading = false;

          if (response.data.result === "0000") {
            this.weekdays = response.data.data;
            this.brandCode = this.search.brandsCode
          } else if (response.data.result === "0006") {
            this.$parent.logOut(true, true);
          } else {
            this.weekdays = [];
            miniToastr.error(response.data.message, "資料讀取異常");
            console.log(response.data.message);
          }
        })
        .catch((error) => {
          this.weekdays = [];
          this.$parent.Loading = false;
          miniToastr.error(error, "資料讀取異常");
          console.log(error);
        });
    },
    setStartDate() {
      var date = new Date();
      var year = date.getFullYear();
      var mon = date.getMonth() + 1;
      var day = date.getDate();

      if (mon < 10) {
        mon = "0" + mon;
      }
      if (day < 10) {
        day = "0" + day;
      }
      this.search.sdate = year + "-" + mon + "-" + day;
      this.today = year + "-" + mon + "-" + day;
      this.today2 = year + "/" + mon + "/" + day;
    },
    // 新增
    ddlCityChange() {
      this.ddl_district = this.ddl_city.Districts[0];
      this.ddlDistrictChange();
    },
    ddlDistrictChange() {
      var count = 0;
      this.ddl_district.Stores.forEach((i) => {
        var result = this.multiple_stores
          .map(function (item, index) {
            return item.ID;
          })
          .indexOf(i.ID);
        if (result > -1) {
          count += 1;
        }
      });
      if (this.ddl_district.Stores.length === count) {
        this.chk_all_selected = true;
      } else {
        this.chk_all_selected = false;
      }
    },
    addMultStores() {
      this.valid_stores = false;
      this.selected_stores = [];
      this.multiple_stores.forEach((i) => {
        this.selected_stores.push(i);
      });
    },
    toggleAll(checked) {
      if (checked) {
        this.ddl_district.Stores.forEach((i) => {
          var result = this.multiple_stores
            .map(function (item, index) {
              return item.ID;
            })
            .indexOf(i.ID);
          if (result === -1) {
            this.multiple_stores.push(i);
          }
        });
      } else {
        this.ddl_district.Stores.forEach((i) => {
          var result = this.multiple_stores
            .map(function (item, index) {
              return item.ID;
            })
            .indexOf(i.ID);
          if (result > -1) {
            this.multiple_stores.splice(result, 1);
          }
        });
      }
    },
    delStore(item) {
      var idx = this.selected_stores.indexOf(item);
      if (idx > -1) {
        this.selected_stores.splice(idx, 1);
      }
      var idx2 = this.multiple_stores.indexOf(item);
      if (idx2 > -1) {
        this.multiple_stores.splice(idx2, 1);
      }
    },
    getAllStores() {
      this.$parent.Loading = true;
      return axios
        .post(API_URL + "/web/marketing/getallstores/v1", {
          status: 1,
          brandCode: this.search.brandsCode
        })
        .then((response) => {
          this.$store.commit("TOKEN", response.data.jwt);
          this.$parent.Loading = false;

          if (response.data.result === "0000") {
            this.stores = response.data.data;
          } else if (response.data.result === "0006") {
            this.$parent.logOut(true, true);
          } else {
            miniToastr.error(response.data.message, "門市資料讀取異常");
            console.log(response.data.message);
          }
        })
        .catch((error) => {
          this.$parent.Loading = false;
          miniToastr.error(error, "門市資料讀取異常");
          console.log(error);
        });
    },
    add() {
      this.hdates = "";
      this.hdatee = "";
      this.store_type = 2;
      this.ddl_city = 0;
      this.ddl_district = 0;
      this.valid_hdates = "";
      this.valid_hdatee = "";
      this.multiple_stores = [];
      this.selected_stores = [];
      this.chk_all_selected = false;
      if (this.brandCode != this.search.brandsCode) {
        this.getquery(this.search.sdate)
      }
      this.getAllStores();
      this.$refs.mdEdit.show();
    },
    addCheck() {
      this.valid_errMsg = false;
      if (!this.hdates) {
        this.valid_errMsg = true;
        this.valid_hdates = "日期為必填";
      } else {
        if (this.hdates !== "" && this.hdates < this.today) {
          this.valid_errMsg = true;
          this.valid_hdates = "起始日不可為今天以前";
        } else {
          this.valid_hdates = "";
        }
      }

      if (!this.hdatee) {
        this.valid_errMsg = true;
        this.valid_hdatee = "日期為必填";
      } else {
        if (this.hdatee !== "" && this.hdatee < this.today) {
          this.valid_errMsg = true;
          this.valid_hdatee = "結束日不可為今天以前";
        } else {
          this.valid_hdatee = "";
        }
      }

      if (this.hdates > this.hdatee) {
        miniToastr.error("起始日不可大於結束日");
        return;
      }

      if (this.store_type == 2 && this.selected_stores.length == 0) {
        miniToastr.error("請選擇門市");
        return;
      }

      if (this.valid_errMsg) {
        this.$parent.$parent.verificationErrMsg();
        return;
      }
      this.$refs.mdCancelCheck.show();
    },
    addsave() {
      this.addsaveClick = true;
      this.$parent.Loading = true;

      var sID = "";
      if (this.store_type == 2) {
        //eslint-disable-line
        this.selected_stores.forEach(function (i) {
          sID += i.ID + ",";
        });
        sID = sID.substring(0, sID.length - 1);
      }
      this.$refs.mdCancelCheck.hide();

      return axios
        .post(API_URL + "/web/shopping/StoreHolidayCreate", {
          hdates: this.hdates,
          hdatee: this.hdatee,
          storeType: Number(this.store_type),
          storeID: sID,
          brandCode: this.brandCode
        })
        .then((response) => {
          this.$store.commit("TOKEN", response.data.jwt);
          this.$parent.Loading = false;
          this.addsaveClick = false;
          if (response.data.result === "0000") {
            this.$refs.mdEdit.hide();
            miniToastr.success("新增成功");
            // 列表切到剛剛新增的日期
            this.getquery(this.hdates);
          } else if (response.data.result === "0006") {
            this.$parent.logOut(true, true);
          } else if (response.data.result === "1114") {
            miniToastr.error("區間已有全門市店休，請重新設定", "資料新增失敗");
          } else {
            miniToastr.error(response.data.message, "資料新增失敗");
          }
        })
        .catch((error) => {
          this.$parent.Loading = false;
          miniToastr.error(error, "資料新增失敗");
          console.log(error);
        });
    },
    addCancel() {
      this.hdates = "";
      this.hdatee = "";
      this.store_type = 2;
      this.ddl_city = 0;
      this.ddl_district = 0;
      this.multiple_stores = [];
      this.selected_stores = [];
      this.chk_all_selected = false;
      this.$refs.mdEdit.hide();
    },
    closeCancelCheck() {
      this.$refs.mdCancelCheck.hide();
    },
    // 刪除
    openDelMode() {
      this.delmode = true;
    },
    closeDelMode() {
      this.delmode = false;
    },
    showDelete(x, Source, theDate, week) {
      this.md_ID = x.ID;
      this.md_BrandCode = x.BrandCode;
      this.md_StoreCode = x.StoreCode;
      if (x.Type == 1) {
        this.md_Name = "全門市";
      } else {
        this.md_Name = x.StoreName;
      }
      this.md_week = week;
      this.md_Source = Source;
      this.md_theDate = theDate;
      this.$refs.mdDelete.show();
    },
    delConfirm() {
      this.$refs.mdDelete.hide();

      this.$parent.Loading = true;
      return axios
        .post(API_URL + "/web/shopping/StoreHolidayDelete", {
          id: this.md_ID,
          storeCode: this.md_StoreCode,
          workDate: this.md_theDate,
          source: this.md_Source,
          week: this.md_week
        })
        .then((response) => {
          this.$store.commit("TOKEN", response.data.jwt);
          this.$parent.Loading = false;

          if (response.data.result === "0000") {
            miniToastr.success("刪除成功");
            this.query("");
          } else if (response.data.result === "0006") {
            this.$parent.logOut(true, true);
          } else {
            miniToastr.error(response.data.message, "資料變更錯誤");
            console.log(response.data.message);
          }
        })
        .catch((error) => {
          this.$parent.Loading = false;
          miniToastr.error(error, "資料變更錯誤");
          console.log(error);
        });
    },
    delCancel() {
      this.$refs.mdDelete.hide();
    },
    querySelectListBrands() {
      //品牌下拉選單
      axios
        .post(API_URL + "/web/brands/v1", {
          all: false,
          order: true
        })
        .then(response => {
          this.selectListBrands = response.data.data;
          this.$parent.Loading = false;
        })
        .catch(error => {
          this.selectListBrands = [];
          this.$parent.Loading = false;
          miniToastr.error(error, "資料讀取異常");
          console.log(error);
        });
    },
  },
};
</script>
<style scoped>
fieldset {
  padding: 8px 22px 18px;
  margin: 0 2px 5px;
  border: 1px solid silver;
}
legend {
  padding: 0.2em;
  border: 0;
  width: auto;
}
.my-scrollbar {
  width: 35%;
  height: 240px;
  min-width: 100%;
  overflow: auto;
}
.box1color {
  margin: auto;
  border: 1px solid silver;
}
.linkbutton {
  background-color: transparent;
  text-decoration: underline;
  border: none;
  color: blue;
}
</style>



// WEBPACK FOOTER //
// src/pages/shopping/storeholiday/List.vue